<template>
  <CChartLine
    :datasets="datasets"
    :options="defaultOptions"
    :labels="yLabels"
  />
</template>

<script>
import { CChartLine } from '@coreui/vue-chartjs'

export default {
  name: 'MainChart',
  components: {
    CChartLine
  },
  props : ['yLabels','datasets','max','stepSize'],
  computed: {
    defaultOptions () {
      
      return {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 5,
              stepSize: this.stepSize,
              max: this.max
            },
            gridLines: {
              display: true
            }
          }]
        },
        elements: {
           line: {
            tension: 0.1
          },
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        }
      }
    }
  }
}
</script>
